import type { History } from 'history';
import { parse } from 'query-string';

import { filterQueryParams } from './filterQueryParams';
import { getListUrl } from './urls';

export const navigate = (history: History, pathname: string) =>
  history.push({
    pathname,
    search: filterQueryParams(history.location.search),
  });

navigate.push = navigate;

export const navigateToBrandList = (history: History) => {
  const { redirectUrl } = parse(location.search);
  if (redirectUrl) {
    window.location.pathname = redirectUrl as string;
  } else {
    navigate(history, getListUrl());
  }
};
